const communityVerbs = [
  {
    verb: 'Escucha',
    subtitle: 'Radios en vivo',
    icon: 'ri-headphone-line',
    color: 'from-rose-500 to-rose-600',
    bgLight: 'bg-rose-50',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-200',
  },
  {
    verb: 'Comparte',
    subtitle: 'Momentos y enlaces',
    icon: 'ri-share-forward-line',
    color: 'from-sky-500 to-sky-600',
    bgLight: 'bg-sky-50',
    textColor: 'text-sky-700',
    borderColor: 'border-sky-200',
  },
  {
    verb: 'Descubre',
    subtitle: 'Nuevas estaciones',
    icon: 'ri-compass-3-line',
    color: 'from-amber-500 to-amber-600',
    bgLight: 'bg-amber-50',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-200',
  },
  {
    verb: 'Conecta',
    subtitle: 'Con locutores y oyentes',
    icon: 'ri-user-heart-line',
    color: 'from-emerald-500 to-emerald-600',
    bgLight: 'bg-emerald-50',
    textColor: 'text-emerald-700',
    borderColor: 'border-emerald-200',
  },
  {
    verb: 'Participa',
    subtitle: 'Chat, encuestas y saludos',
    icon: 'ri-chat-smile-3-line',
    color: 'from-violet-500 to-violet-600',
    bgLight: 'bg-violet-50',
    textColor: 'text-violet-700',
    borderColor: 'border-violet-200',
  },
  {
    verb: 'Compite',
    subtitle: 'Batallas y torneos',
    icon: 'ri-sword-line',
    color: 'from-orange-500 to-orange-600',
    bgLight: 'bg-orange-50',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
  },
  {
    verb: 'Gana',
    subtitle: 'Insignias, niveles y premios',
    icon: 'ri-trophy-line',
    color: 'from-yellow-500 to-yellow-600',
    bgLight: 'bg-yellow-50',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-200',
  },
];

const followItems = [
  { label: 'Sigue Radios', icon: 'ri-radio-line', desc: 'Tu música, tu gente, tu frecuencia favorita siempre cerca.' },
  { label: 'Sigue Locutores', icon: 'ri-mic-line', desc: 'Conectá con las voces que te acompañan cada día.' },
  { label: 'Sigue Programas', icon: 'ri-calendar-check-line', desc: 'No te pierdas ningún episodio de lo que más te gusta.' },
];

export default function CommunityVerbsSection() {
  return (
    <section id="community-verbs" className="relative py-20 md:py-28 overflow-hidden bg-background-50">
      {/* Ambient background elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-rose-500/3 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-sky-500/3 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-500/2 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        {/* ── HEADER ── */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200 text-accent-700 text-xs font-semibold mb-5">
            <i className="ri-heart-pulse-line text-xs"></i>
            El latido de la comunidad
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Escuchar radio{' '}
            <span className="text-accent-600">nunca fue tan social</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            RFW transforma cada oyente en protagonista. No venís solo a escuchar: venís a compartir, descubrir, conectar, participar, competir y ganar.
          </p>
        </div>

        {/* ── 7 VERBS GRID ── */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4 mb-16">
          {communityVerbs.map((item) => (
            <div
              key={item.verb}
              className="group relative flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-background-300/60 transition-all duration-300 hover:-translate-y-1 hover:shadow-sm"
            >
              {/* Gradient icon circle */}
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${item.color} text-background-50 mb-3 transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-extrabold text-foreground-950 mb-1">
                {item.verb}
              </span>
              <span className="text-[11px] md:text-xs text-foreground-500 leading-tight">
                {item.subtitle}
              </span>
            </div>
          ))}
        </div>

        {/* ── SIGUE RADIOS / LOCUTORES / PROGRAMAS ── */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-100 text-foreground-500 text-xs font-medium">
              <i className="ri-user-follow-line"></i>
              Nunca pierdas el hilo de lo que te importa
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {followItems.map((item, idx) => (
              <div
                key={item.label}
                className="group relative rounded-2xl border border-background-200/70 bg-background-100 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:border-accent-200 hover:shadow-sm text-center"
              >
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-500 text-background-50 mb-4 transition-all duration-300 group-hover:scale-110">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="text-foreground-950 font-bold text-sm md:text-base mb-2">{item.label}</h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── BOTTOM MESSAGE: COMMUNITY FIRST ── */}
        <div className="mt-14 text-center">
          <div className="relative inline-block rounded-2xl border-2 border-dashed border-accent-300/60 bg-accent-50/50 p-6 md:p-8 max-w-2xl mx-auto">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-[10px] font-bold uppercase tracking-wider">
                <i className="ri-radio-button-line text-[9px]"></i>
                Lo más importante
              </span>
            </div>
            <p className="text-foreground-800 font-bold text-base md:text-lg leading-relaxed mt-2">
              La comunidad siempre será el producto principal.
            </p>
            <p className="mt-2 text-foreground-500 text-xs md:text-sm leading-relaxed">
              RFW no es un servicio de streaming. Somos la red social donde las radios y sus comunidades viven, crecen y compiten. El audio es solo el principio — la magia está en la gente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}